import { BrowserRouter, Switch, Route } from "react-router-dom";
import ProtectedRoute from "./protectedRoutes";
import { history } from "../Redux/Store";

import LoginPage from "../Components/Login/login";
import LandingPage from "../Components/Landing/landing";
import Home from "../Components/Home/home";
import ChangePassword from "../Components/Login/changePassword";
import Notifications from "../Components/Notifications";
import DocumentVault from "../Components/DocumentVault";
import Checkout from "../Components/Checkout/checkout";
import Setting from "../Components/Setting/Setting";
import Companies from "../Components/Companies/companies";
import Jobs from "../Components/jobs/jobs";
import Create from "../Components/jobs/create";
import Info from "../Components/jobs/info"
import JobEdit from "../Components/jobs/edit"
import CompanyInfo from "../Components/Companies/companyInfo";
import JobDetail from "../Components/jobs/jobDetail";
import EmiratesIdCreate from "../Components/EmiratesIdPage/create";
import ConsolidatedReport from "../Components/Reports/ConsolidatedReport";
const Routes = () => {
  return (
    <BrowserRouter>
      <Switch history={history}>
        <Route exact path="/" component={LandingPage} />
        <Route exact path="/landing" component={LandingPage} />
        <Route exact path="/login" component={LoginPage} />
        <ProtectedRoute
          exact
          path="/dashboard"
          component={Home}
        />
        <ProtectedRoute
          exact
          path="/home"
          component={Home}
        />
        <ProtectedRoute
          exact
          path="/jobs"
          component={Jobs}
        />
        <ProtectedRoute
          exact
          path="/jobs/create"
          component={Create}
        />
        <ProtectedRoute
          exact
          path="/notifications"
          component={Notifications}
        />
        <ProtectedRoute
          exact
          path="/change-password"
          component={ChangePassword}
        />
        <ProtectedRoute
          exact
          path="/documentVault"
          component={DocumentVault}
        />
        <ProtectedRoute
          exact
          path="/checkout/:jobID"
          component={Checkout}
        />
        <ProtectedRoute
          exact
          path="/setting"
          component={Setting}
        />
        <ProtectedRoute
          exact
          path="/companies"
          component={Companies}
        />
        <ProtectedRoute
          exact
          path="/corporate-jobs/:id"
          component={Info}
        />
        <ProtectedRoute
          exact
          path="/corporate-jobs-edit/:id"
          component={JobEdit}
        />
        <ProtectedRoute
          exact
          path="/company-info/:id"
          component={CompanyInfo}
        />
        <ProtectedRoute
          exact
          path="/job-detail/:jobID"
          component={JobDetail}
        />
        <ProtectedRoute
          exact
          path="/job-eid-basmati-create"
          component={EmiratesIdCreate}
        />
        <ProtectedRoute
          exact
          path="/reports/consolidated"
          component={ConsolidatedReport}
        />
      </Switch>
    </BrowserRouter>
  );
};

export default Routes;
